import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseListComponent } from '../../shared/base-list/base-list.component';

@Component({
  selector: 'app-ping-log',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./ping-log.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class PingLogComponent extends BaseListComponent implements OnInit, OnChanges {

  @Input() userid: any;
  @Input() issueid: any;

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entity = 'ping_log';

  }

  getBody(): any {
    const body = super.getBody();
    if (this.userid) {
      body['query'] = [
        'user_id', '=', this.userid
      ];
    }
    if (this.issueid) {
      body['query'] = [
        'issue_id', '=', this.issueid
      ];
    }
    return body;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userid && this.meta) {
      this.load();
    }
  }

}
